import {
  createBannerURL,
  createFileUploadPageURL,
  createIconURL,
  createProfilePageURL,
} from "#lib/urls";
import { ImageBackground, ImageLink } from "#components/images";
import { paysites } from "#entities/paysites";
import { FavoriteButton } from "#components/favorite-button";
import { Creator } from "#api/creators";

interface IProps {
  creator: Creator;
}

/**
 * TODO: asset imports instead of literal paths
 */
const paysiteIcons = {
  patreon: "/static/patreon.svg",
  fanbox: "/static/fanbox.svg",
  boosty: "/static/boosty.svg",
  gumroad: "/static/gumroad.svg",
  subscribestar: "/static/subscribestar.png",
  dlsite: "/static/dlsite.png",
  fantia: "/static/fantia.png",
  onlyfans: "/static/onlyfans.svg",
  fansly: "/static/fansly.svg",
  candfans: "/static/candfans.png",
} as const;

export function CreatorHeader({ creator }: IProps) {
  const { service, id: creatorId, name } = creator;
  const artistIcon = createIconURL(service, creatorId);
  const artistBanner = createBannerURL(service, creatorId);
  const externalProfileURL = paysites[service].user.profile(creator);
  const paysiteIconURL = paysiteIcons[service as keyof typeof paysiteIcons];

  return (
    <header className="user-header">
      <ImageBackground
        className="user-header__background"
        src={artistBanner}
        isLazy={false}
      />
      {/* TODO: remove self-referencing link */}
      <ImageLink
        url={String(createProfilePageURL({ service, creatorId }))}
        src={artistIcon}
        isLazy={false}
        isNoop={false}
        className="user-header__avatar"
      />

      <div className="user-header__info">
        <h1 id="user-header__info-top" className="user-header__name">
          <a
            className="user-header__profile"
            href={externalProfileURL}
            target="_blank"
            rel="noreferrer"
            itemProp="url"
          >
            <span className="user-header__profile-image">
              <img src={paysiteIconURL} />
            </span>
            <span itemProp="name">{name}</span>
          </a>
        </h1>

        <div className="user-header__actions">
          <a
            className="user-header__upload"
            href={String(createFileUploadPageURL(service, creatorId))}
          >
            <span>Upload file</span>
          </a>

          <FavoriteButton service={service} creatorId={creatorId} />
        </div>
      </div>
    </header>
  );
}
